const ADD_PURCHASE_ORDER = "ADD_PURCHASE_ORDER";
const DELETE_PURCHASE_ORDER = "DELETE_PURCHASE_ORDER";
const PURCHASE_ORDERS = "PURCHASE_ORDERS";
const ADD_PURCHASE_ORDER_ERROR = "ADD_PURCHASE_ORDER_ERROR";
const PURCHASE_ORDER_DETAILS = "PURCHASE_ORDER_DETAILS";
const UPDATE_PURCHASE_ORDER = "UPDATE_PURCHASE_ORDER";
const PURCHASE_ORDER_REPORTS = "PURCHASE_ORDER_REPORTS";

export {
  ADD_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER,
  PURCHASE_ORDERS,
  ADD_PURCHASE_ORDER_ERROR,
  PURCHASE_ORDER_DETAILS,
  UPDATE_PURCHASE_ORDER,
  PURCHASE_ORDER_REPORTS,
};
